module.exports = __webpack_public_path__ + "img/IMG_4942_stitch.f7b91118.jpg";